module.exports = __webpack_public_path__ + "img/1160_MILR_Website_NJAB_8.a5c2601a.png";